export const playJoinChime = () => {
  try {
    const audio = new Audio("/sounds/chime.mp3");
    audio.play().catch((e) => {
      console.error("Failed to play join chime", e);
    });
  } catch (e) {
    console.error("Failed to initialize join chime", e);
  }
};

let keepAliveContext: AudioContext | null = null;
let keepAliveOscillator: OscillatorNode | null = null;

export const startAudioKeepAlive = () => {
  try {
    if (keepAliveContext) return; // Already running

    const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContext) return;

    keepAliveContext = new AudioContext();
    keepAliveOscillator = keepAliveContext.createOscillator();
    const gainNode = keepAliveContext.createGain();

    // Set volume to 0 (silent)
    gainNode.gain.value = 0;

    keepAliveOscillator.connect(gainNode);
    gainNode.connect(keepAliveContext.destination);

    keepAliveOscillator.start();
  } catch (e) {
    console.error('Failed to start audio keep-alive', e);
  }
};

export const stopAudioKeepAlive = () => {
  if (keepAliveOscillator) {
    try {
      keepAliveOscillator.stop();
    } catch (e) {
      console.error('Failed to stop audio keep-alive', e);
    }
    keepAliveOscillator = null;
  }
  if (keepAliveContext) {
    keepAliveContext.close();
    keepAliveContext = null;
  }
};
